// auth.guard.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { ClientService } from './shared/services/client.service';
//import decode from 'jwt-decode';

@Injectable()
export class AuthGuard implements CanActivate {
  
  _redirectURL: string = '/auth/login'
  user: any = {};
  client: any = {};
  constructor(private router: Router, private authService: AuthService, private clientService: ClientService) {
    this.user = this.authService.getUser();
    this.client = this.clientService.getClient();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
     this.user = this.authService.getUser();
    this.client = this.clientService.getClient();
    //if (this.user == null) {
    //  // logged in so return true
    //  //this.router.navigate([this._redirectURL], { queryParams: { returnUrl: state.url } });
    // // this.router.navigate([this._redirectURL]);
    //  this.router.navigateByUrl(this._redirectURL);
    //  //check if token has expired
    //  //let isTokenExpired = tokenNotExpired(null, this.user.auth_token);
    //  //if (isTokenExpired)
    //  //{
    //  //  this.router.navigate([this._redirectURL], { queryParams: { returnUrl: state.url, expired: true } });

    //  //}
    //}

    //console.log(state.url);

    if (state.url.toLowerCase().indexOf("xpro/signature") > -1) {
      // logged in so return true
      return true;
    }
    else if (state.url.toLowerCase().indexOf("ignt/asset-validation") > -1) {
      // logged in so return true
      return true;
    }
    //check for custom links 
    if (this.client != null && this.user != null) {
      var returnBool = false;
      var menus = this.client.clientSetting.navigationSetting.menus;
      for (var menu in menus) {
        var data = menus[menu].subMenus.find(x => x.url == state.url );
        if (data != undefined) {
          if (data.isActive == false) {
            this.router.navigate(['/miscellaneous/error404']);
          }
          if ((this.user.IsUserSystemAdmin != null && this.user.IsUserSystemAdmin) || (this.user.IsUserClientAdmin != null || this.user.IsUserClientAdmin))
            return true;

          //now check for menu roles
          if (data.roles != null && data.roles.length > 0)
          {
            data.roles.forEach(
              role => {
                var index = this.user.roles.indexOf(role.role);
                if (index > -1) {
                  returnBool = true;
                  return;
                }

              }
            );
            if (returnBool)
              return true;
            else
             this.router.navigate(['/miscellaneous/error404']);
          }
          
        }
      }      
    }

    //check for admin user-management
    if (this.user != null && state.url.toLowerCase().indexOf("admin/user-management") > -1)
    {
      if ((this.user.IsUserSystemAdmin != null && this.user.IsUserSystemAdmin) || (this.user.IsUserClientAdmin != null || this.user.IsUserClientAdmin))
      {
        return true;
      }
      this.router.navigate(['/miscellaneous/error404']);
    }

    //check for admin client-management
    if (this.user != null && state.url.toLowerCase().indexOf("admin/client-management") > -1) {
      if ((this.user.IsUserSystemAdmin != null && this.user.IsUserSystemAdmin) )
      {
        return true;
      }
      this.router.navigate(['/miscellaneous/error404']);
    }

    //reached here. now just check for if logged in
    if (this.user != null) {
      // logged in so return true
      return true;
    }

   // this.router.navigate([this._redirectURL], { queryParams: { returnUrl: state.url } });
    this.router.navigateByUrl(this._redirectURL);
    // not logged in so redirect to login page with the return url
  //comment added
  }
}
